import { graphql } from 'gql/generated'

export const CREATE_PAYMENT_SUMMARY = graphql(`
  mutation CreatePaymentSummary($input: CreatePartnersPaymentSummaryInput!) {
    createPartnersPaymentSummary(input: $input) {
      id
    }
  }
`)

export const ADD_PAYMENT_SUMMARY_FILES = graphql(`
  mutation AddPaymentSummaryFiles($input: AddPartnersPaymentSummaryFilesInput!) {
    addPartnersPaymentSummaryFiles(input: $input)
  }
`)

export const SEND_PARTNERS_PAYMENT_SUMMARY_EMAILS = graphql(`
  mutation SendPartnersPaymentSummaryEmails($input: SendPartnersPaymentSummaryEmailsInput!) {
    sendPartnersPaymentSummaryEmails(input: $input)
  }
`)
